import brandConfig from '~branding/brussels/config.js'
import TermsOfUsePage from '~brand-pages/brussels/terms-of-use'
import FAQPage from '~brand-pages/brussels/faq'
import VoucherSaleAmountPage from '~brand-pages/brussels/voucher-sale-amount'
import VoucherSaleCheckoutPage from '~brand-pages/brussels/voucher-sale-checkout'
import VoucherSaleConfirmationPage from '~brand-pages/brussels/voucher-sale-confirmation'
import VoucherSaleLandingPage from '~brand-pages/brussels/voucher-sale'

import routerBuilder from './routerBuilder'

const router = routerBuilder('brussels', {
  brandConfig,
  TermsOfUsePage,
  TermsOfUsePageCompensation: null,
  VoucherSaleAmountPage,
  VoucherSaleCheckoutPage,
  VoucherSaleConfirmationPage,
  FAQPage,
  VoucherSaleLandingPage,
}, ['en', 'fr', 'nl'])

export default router
